import { useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { useEventListener } from "usehooks-ts";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CreateFormInputField,
  deleteFormInputField,
  editFormInputField,
  getFormInputFieldById,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import Button from "../../Button/Button";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import Input from "../../Input/Input";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import "./AddInputFields.scss";

const AddInputFields = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
}) => {
  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const Form_Key = "Input_Fields";
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Input_Fields?.Selected_Row;
  const [toggle, settoggle] = useState(show ? show : false);
  const [allFieldsData, setAllFieldsData] = useState({});
  const [options, setOptions] = useState(["", ""]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const dispatch = useDispatch();

  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: createFormFieldLoading }] = useMutation(CreateFormInputField);

  const [GetDataByID, { loading: getFormFieldByIdLoading }] = useLazyQuery(getFormInputFieldById, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: editFormFieldByIdLoading }] = useMutation(editFormInputField);

  const [DeletingData, { loading: deleteFormFieldLoading }] = useMutation(deleteFormInputField);

  const FormSectionLoadingState =
    createFormFieldLoading || getFormFieldByIdLoading || editFormFieldByIdLoading || deleteFormFieldLoading;

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Input_Fields?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      getFormSectionAndFields().then(() => {
        GetDataByID({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let FormFieldData = {
            ...data?.getFormFieldById,
          };
          console.log("FormFieldData", FormFieldData);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Section_Id: FormFieldData?.Section_Id,
              },
            },
          });

          FormFieldData.Section_Id = FormFieldData?.Section_Id?.name;
          if (FormFieldData?.dropdowncontent?.length > 0) {
            setOptions(FormFieldData?.dropdowncontent || ["", ""]);
          }
          setAllFieldsData(FormFieldData);
          updateValueForm(formRef, FormFieldData);
        });
      })

    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const HanldeChangeonForm = (values) => {
    console.log(values)
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction) => {
    console.log(formData)
    formData.Section_Id = FormDataFromRedux?.MasterData[Form_Key]?.Section_Id?._id;
    formData.dropdowncontent = [];
    options[0] !== "" && (FormData?.type === "Dropdown" || FormData?.type === "Multi-Select") && (formData.dropdowncontent = options);
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: (res) => {
          handleFormReset(formRef);
          setOptions(["", ""]);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => {
        setOptions(["", ""]);
        if (operationType === "Edit" || operationType === "Delete") {
          dispatch({ type: "Refetch", payload: true });
        }
      },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = useCallback(() => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    setOptions(["", ""]);
    ClearSpecificForm(dispatch, Form_Key);
  }, []);

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };



  const addOption = () => {
    setOptions([...options, ""]);
  };
  const removeOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };
  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };


  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={FormSectionLoadingState}
        />
      </Reactportal>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
            Validate_handleSubmit(SaveAndCloseForAdd);
          }
          : () => {
            Validate_handleSubmit(submit);
          }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={FormSectionLoadingState}
    />
  );

  return (
    <>
      <Reactportal FoooterContent={footerContent} open={toggle} onClose={Closeformfunction} TypeOfPortal={TypeOfPortal + " FormFields"}>
        {FormSectionLoadingState && <div className="loader-line-div" />}
        <div className="formContainer">
          {inputFields && inputFields?.length > 0 ? (
            inputFields?.map((e) => (
              <div className="FormSectionParent">
                <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                <div className="FormSection insidecontainerForThreeSideBySide">
                  <FormInputSectionComponent
                    inputfields={e.fields}
                    Type={e.name}
                    TypeOfPortal={TypeOfPortal}
                    onErrorsChange={handleErrorsChange}
                    onhandleFormikChange={HanldeChangeonForm}
                    formRef={formRef}
                    formkey={Form_Key}
                  />
                </div>
              </div>
            ))
          ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
            <p>No form fields available.</p>
          ) : null}
          {(FormData?.type === "Dropdown" || FormData?.type === "Multi-Select") && (
            <>
              {/* <div className="sectionHeadings">Dropdown Options:</div> */}
              <div className="form-group-input-fields">
                {options.map((option, index) => (
                  <div key={index} className="option-input">
                    <Input
                      type="text"
                      value={option}
                      handleInputChange={(e) => handleOptionChange(index, e.target.value)}
                      modalform={true}
                      label={`Option ${index + 1}`}
                    />
                    {options.length > 2 && (
                      // <button type="button" onClick={() => removeOption(index)}>
                      <RxCross2 className="cross-Icon" onClick={() => removeOption(index)} />

                      // </button>
                    )}
                  </div>
                ))}
                <div>
                  <Button name="modalbutton" text=" Add Option" action={addOption} />
                </div>
              </div>
            </>
          )}
        </div>
      </Reactportal>
    </>
  );
};

export default AddInputFields;
